export default __webpack_public_path__ + "static/media/memory.141ca0a2.webp";